export enum CanvasOrientation {
  SQUARE = "square",
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
}

export enum Backdrop {
  NIGHTTIME = "nighttime",
  FOREST = "forest",
  MOUNTAINS = "mountains",
}

export enum Hackpal {
  GINNY = "ginny",
  PATCH = "patch",
  VINYL = "vinyl",
}

// Maps to the "How are they feeling today?" options:
// default = "The usual", sparkle = "In awe", snooze = "Ready for a nap"
export enum Feeling {
  DEFAULT = "default",
  SPARKLE = "sparkle",
  SNOOZE = "snooze",
}

export enum Accessory {
  NONE = "none",
  INSTRUMENT = "instrument",
  PLANT = "plant",
  WRENCH = "wrench",
}

export enum Effect {
  NONE = "none",
  EXCITEMENT = "excitement",
  MUSIC = "music",
  SPARKLES = "sparkles",
}

export enum HeaderTextOption {
  IM_GOING = "im-going",
  SEE_YOU = "see-you",
}

export enum SignOption {
  DREAM_BIG = "dream-big",
  LOOKING_FOR_TEAM = "looking-for-team",
  BUILDING = "building",
}

export interface GraphicCustomization {
  orientation: CanvasOrientation;
  backdrop: Backdrop;
  hackpal: Hackpal;
  feeling: Feeling;
  accessory: Accessory;
  effect: Effect;
  headerText: HeaderTextOption;
  signOption: SignOption;
  /** Suffix after "I'm building " when signOption === BUILDING */
  buildingText: string;
  /** Name drawn on the ink stamp (defaults to profile first name) */
  stampName: string;
}
